var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('canvas',{staticClass:"canvas-h canvas-w",attrs:{"id":"tpeNinos0a2A"}})])
}]

export { render, staticRenderFns }